


























import BuyNowButton from './BuyNowButton';

export default BuyNowButton.extend({
  name: 'HotelsBuyNowButton',
  computed: {
    buttonText() {
      if (!this.isForSale) {
        return (this as any).$t('12835.App_hotelDetailsBookButtonSoldOut');
      }
      return (this as any).$t('28272.App_HotelDealAvailabilityBuyNowCartButtonTitle');
    },
  },
});
